import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { fireLogger } from '../../core/utils/fire-logger';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService:AuthService,
  ) { }

  canActivate() {

    return this.authService.authenticateJwt()
      .then(response => {
        if (response.user.isAdmin !== true) {
          fireLogger.log('Not an admin!');
          this.authService.logout(false);
          throw new Error('NOT_AN_ADMIN');
        } else {
          return true;
        }
      })
      .catch(err => {
        if (err.message && err.message == 'NOT_AN_ADMIN') {
          this.router.navigate(['/login', {err: 'not-admin'}]);
        } else {
          this.router.navigate(['/login']);
        }
        return false;
      });

  }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/guards/auth.guard.ts